(function () {
  'use strict';

  function fire(name) {
    if (window.clarity && typeof window.clarity === 'function') {
      try { window.clarity('event', name); } catch (e) {}
    }
  }

  function init() {
    if (typeof window.subscribe === 'function') {
      window.subscribe('cart-update', function (payload) {
        if (payload && payload.source === 'product-form') {
          fire('AddToCart');
        }
      });
    }

    document.addEventListener('click', function (e) {
      var hit = e.target && e.target.closest && e.target.closest(
        '[name="checkout"], .cart__checkout, [data-cart-checkout-button] button[type="submit"]'
      );
      if (hit) fire('BeginCheckout');
    }, true);

    document.addEventListener('theme:cart-drawer:open', function () {
      fire('CartDrawerOpened');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
